<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateLeaveWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create A Leave Workflow</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Workflow Name</label>
              <input
                v-model="info.Name"
                type="text"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1 capitalize">Company</label>
              <select
                name=""
                id=""
                v-model="info.LocationId"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="() => setBranches()"
              >
                <option v-for="location in locations" :key="location.Id">
                  {{ location.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">Branch</label>
              <select
                name=""
                id=""
                v-model="info.BranchId"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="() => setDepartments()"
              >
                <option
                  v-for="branch of branchesToSelect"
                  :key="branch.Id"
                  :disabled="!info.LocationId"
                >
                  {{ branch.Name }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Department</label>

              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.DepartmentName"
                placeholder="Select a type"
                :disabled="!info.BranchId"
                @change="getDepartmentId"
              >
                <el-option
                  v-for="department in departmentsToSelect"
                  :key="department.Name"
                  :label="department.Name"
                  :value="department.Name"
                >
                </el-option>
              </el-select>
              <small
                v-if="info.BranchId && branchesToSelect.length === 0"
                class="text-sm italic"
                style="
                  color: rgba(222, 164, 44, var(--tw-bg-opacity));
                  --tw-bg-opacity: 1;
                "
                >No departments at this branch</small
              >
            </div>

            <div class="text-sm">
              <label class="block text-sm mb-2" for="consecutive-switch">
                Any Can Approve
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="info.AnyCanApprove"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Allow Any Approver to Approve
                </label>
              </div>
            </div>

            <div class="flex justify-end p-5">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupCreateLeaveWorkflow",
  props: ["showCreateLeaveWorkflow", "getWorkflow"],
  components: { Loader },
  data() {
    return {
      info: {
        Name: null,
        LocationId: null,
        LocationName: null,
        BranchId: null,
        DepartmentId: null,
        DepartmentName: null,
        DuplicateSequences: false,
        AnyCanApprove: true,
        BranchName: "",
      },

      create_error: null,
      create_success: null,
      loading: false,
      employees: [],
      departments: [],
      locations: [],
      selectedEmployees: [],
      isOpen: false,
      departmentsToSelect: [],
      branchesToSelect: [],
      branches: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getLocations();
    this.getDepartments();
    this.getEmployees();
    this.getBranches();
  },
  methods: {
    setBranches() {
      this.branchesToSelect = this.branches.filter(
        (branch) => branch.Location === this.info.LocationId
      );
    },
    setDepartments() {
      this.departmentsToSelect = this.departments.filter(
        (department) =>
          department.BranchName === this.info.BranchId &&
          department.LocationName === this.info.LocationId
      );
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.addEventListener("click", this.closeDropdown);
      } else {
        document.removeEventListener("click", this.closeDropdown);
      }
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        document.removeEventListener("click", this.closeDropdown);
      }
    },

    close() {
      this.$emit("close");
      this.info = {
        Name: null,
        LocationId: null,
        DepartmentId: null,
        DuplicateSequences: false,
        AnyCanApprove: false,
      };
      this.selectedEmployees = [];
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      this.info.BranchId = this.branchesToSelect.find(
        (branch) => branch.Name === this.info.BranchId
      ).Id;

      if (this.info.DepartmentId) {
        this.info.LocationId = this.departments.find(
          (department) => department.DepartmentId === this.info.DepartmentId
        ).LocationId;
      } else {
        console.log(this.locations);
        this.info.LocationId = this.locations.find(
          (location) => location.Name.trim() === this.info.LocationId
        ).Id;
      }

      axios
        .post(
          `${this.getOrganization}/setup/leave/workflow/group/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.$emit("closeOnSuccess");
              this.info = {
                Name: null,
                LocationId: null,
                DepartmentId: null,
                DuplicateSequences: false,
                AnyCanApprove: false,
              };
              this.selectedEmployees = [];
              setTimeout(() => {
                this.create_success = null;
                this.close();
              }, 2500);

              this.getWorkflow();
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$store.commit("setEmployees", response.data.Data);

              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // Find branches in a selected location
    getLocationId(e, locationName) {
      const locationId = this.locations.find(
        (location) =>
          location.Name.trim().toLowerCase() ===
          locationName.trim().toLowerCase()
      ).Id;
      this.info.LocationId = locationId;
      this.getBranchesByLocationId(locationName);
    },

    getBranchesByLocationId(locationName) {
      this.branchesToSelect = this.branches.filter(
        (branch) =>
          branch.Location.trim().toLowerCase() ===
          locationName.trim().toLowerCase()
      );
    },

    // Find locations in a selected branch
    getBranchId(e, branchName) {
      const branchId = this.branches.find(
        (branch) =>
          branch.Name.trim().toLowerCase() === branchName.trim().toLowerCase()
      ).Id;
      this.info.BranchId = branchId;
    },

    getDepartmentId(name) {
      const departmentId = this.departments.find(
        (department) => department.Name === name
      ).DepartmentId;
      this.info.DepartmentId = departmentId;
    },

    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.locations = response.data.Data;
              this.locations.forEach((v, index) => {
                v.rowKey = `${index + ``}`;
                v.departments = [];
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/branch/v1/request
    getBranches() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.branches = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.selected-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0.5rem 0;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  overflow-y: auto;
  max-height: 10rem;
}

.dropdown-menu label {
  display: block;
  padding: 0.5rem;
  cursor: pointer;
}

.dropdown-menu input[type="checkbox"] {
  margin-right: 0.5rem;
}

.dropdown-menu label:hover {
  background-color: #f7fafc;
}

.dropdown-menu label:last-of-type {
  margin-bottom: 0;
}

.dropdown-menu::-webkit-scrollbar {
  width: 0.25rem;
}

.dropdown-menu::-webkit-scrollbar-track {
  background-color: #f7fafc;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
}
</style>
